
import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import DbSearch from '../../db/DbSearch';

export default (props) => {
  const { filterSuggestions, allowSelectAll = false, sortBy = '', showAll = false } = props.search; // eslint-disable-line

  const searchProps = {
    filterSuggestions,
    allowSelectAll,
    filterBy: 'id',
    showAll,
    sortBy,
  };

  return <FormInputTagsItem {...props} inputComponent={DbSearch} inputProps={searchProps} />;
};
